module.exports = __webpack_public_path__ + "static/img/product5.17d606db.png";